import { observable } from 'mobx'
import { types } from 'mobx-state-tree'
import { ISO } from 'service/ISO'

const MIN_NUMBER_OF_SHIPMENTS = 2
const MAX_NUMBER_OF_SHIPMENTS = 20

export const BuyersConsolidationQuoteServicesMst = types
  .model('BuyersConsolidationQuoteServices', {
    enabled: types.boolean,
    numberOfShipments: types.maybe(types.number),
    incoterms: types.array(types.enumeration([...ISO.IncoTermsCodes, ...ISO.DeprecatedIncoTermsCodes])),
  })
  .volatile((self) => ({
    // This is currently the only way to determine of number of shipments is unknown or was never set.
    // That is why by default this is true. When manually creating an object in a form, use setPristine().
    // This might be refactored into a separate property instead of having undefined for number of shipments having a
    // meaning, but that might lead to additional backend code.
    numberOfShipmentsTouched: true,
    incotermsTouched: true,
    numberOfShipmentsUnknown: self.numberOfShipments === undefined,
    /**
     * @note Since the entire manual quote request is not using SForm, we have to wrap up our own workaround to display
     * errors. With more time ideally the dialog can be refactored.
     */
    numberOfShipmentsError: undefined as undefined | string,
  }))
  .views((self) => ({
    get isValid() {
      return (
        (self.numberOfShipmentsTouched &&
          self.incotermsTouched &&
          (self.numberOfShipmentsUnknown || self.numberOfShipments)) ||
        self.numberOfShipmentsError
      )
    },
  }))
  .actions((self) => ({
    setPristine() {
      self.numberOfShipmentsTouched = false
      self.numberOfShipmentsUnknown = false
      self.incotermsTouched = false
      self.numberOfShipmentsError = undefined
    },
    setNumberOfShipments(numberOfShipments: number | undefined) {
      self.numberOfShipmentsTouched = true

      self.numberOfShipments = numberOfShipments as number
      self.numberOfShipmentsError = undefined
      if (
        numberOfShipments != null &&
        (numberOfShipments < MIN_NUMBER_OF_SHIPMENTS || numberOfShipments > MAX_NUMBER_OF_SHIPMENTS)
      ) {
        self.numberOfShipmentsError =
          'manual_quote-buyers_consolidation-number_of_shipments-invalid_number_of_shipments_error'
      }
    },
    setIncoterms(incoterms: ISO.IncoTermsCode[]) {
      self.incoterms = observable(incoterms)
      self.incotermsTouched = true
    },
  }))
  .actions((self) => ({
    toggleNumberOfShipmentsUnknown() {
      self.numberOfShipmentsUnknown = !self.numberOfShipmentsUnknown
      self.setNumberOfShipments(undefined)
    },
  }))

export type TBuyersConsolidationQuoteServicesMst = typeof BuyersConsolidationQuoteServicesMst.Type
